export default (theme) => ({
  header: {
    background: theme.palette.primary,
  },
  circleIconDanger: {
    fill: '#C62439',
  },
  circleIconWarning: {
    fill: '#FB9F1E',
  },
  circleIconSuccess: {
    fill: '#00AD5D',
  },
  status: {
    display: 'flex',
    alignItems: 'center',
  },
  viewIcon: {
    fill: '#FFFFFF',
    height: 20,
  },
  tableHeader: {
    backgroundColor: '#ffffff',
    '& th': {
      fontWeight: 'bold',
      color: theme.palette.primary.main,
    },
  },
  payHere: {
    padding: 8,
    height: 30,
    fontSize: 9,
    marginLeft: 8,
    color: '#ffffff',
    fontWeight: 'bold',
  },
  viewInvoice: {
    padding: 8,
    height: 30,
  },
  boxAction: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  boxInline: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& > :first-child': {
      fontWeight: 'bold',
    },
  },
  boxDanger: {
    border: '2px solid #ccc',
    borderRadius: 10,
    padding: 10,
    borderLeftColor: '#C62439',
    borderLeftWidth: 4,
  },
  boxWarning: {
    border: '2px solid #ccc',
    borderRadius: 10,
    padding: 10,
    borderLeftColor: '#FB9F1E',
    borderLeftWidth: 5,
  },
  boxSuccess: {
    border: '2px solid #ccc',
    borderRadius: 10,
    padding: 10,
    borderLeftColor: '#00AD5D',
    borderLeftWidth: 4,
  },
  mobileLeftBox: {
    borderRight: '2px solid #cccccc',
    paddingRight: 5,
  },
  mobileHCS: {
    color: '#000000',
    fontWeight: 'bold',
  },
  textWarning: {
    color: '#FB9F1E',
    fontWeight: 'bold',
    fontSize: 14,
  },
  textSuccess: {
    color: '#00AD5D',
    fontWeight: 'bold',
    fontSize: 14,
  },
  amount: {
    fontWeight: 'bold',
    fontSize: 24,
  },
});
